import {useCallback, useEffect} from "react";

export default function useDragEvents(
    element,
    callback,
    onMouseUpCallback,
    onMouseDownCallback
) {
    const onMouseUp = useCallback(
        (e) => {
            document.removeEventListener("mousemove", callback);
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("touchmove", callback);
            document.removeEventListener("touchend", onMouseUp);
            e.preventDefault();
            if (onMouseUpCallback) onMouseUpCallback(e);
        },
        [callback, onMouseUpCallback]
    );

    const onMouseDown = useCallback(
        (e) => {
            document.addEventListener("mousemove", callback);
            document.addEventListener("mouseup", onMouseUp);
            document.addEventListener("touchmove", callback, {passive: false});
            document.addEventListener("touchend", onMouseUp);
            if (onMouseDownCallback) onMouseDownCallback(e);
        },
        [callback, onMouseUp, onMouseDownCallback]
    );

    useEffect(() => {
        const tmp = element.current;
        tmp.addEventListener("mousedown", onMouseDown);
        tmp.addEventListener("touchstart", onMouseDown, {passive: false});

        return () => {
            tmp.removeEventListener("mousedown", onMouseDown);
            tmp.removeEventListener("touchstart", onMouseDown);
        };
    }, [element, onMouseDown]);
}
